import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';
import { Options } from '@shared/models/options';
import { environment } from '@env/environment';
import { Attachment } from '@shared/models/ticket-info';

@Injectable({
  providedIn: 'root'
})
export class TicketApi extends ApiCommon {
  protected backend = environment.api.backend;

  getTicketFilter(pageEvent, opt?: Options): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (opt?.q) {
      builder.q = opt.q;
    }

    if (opt?.query) {
      builder.query = opt.query;
    }

    if (opt?.filter) {
      builder.filter = opt.filter;
    }

    return this.apiServer.ticket.getTicketFilter(builder.build());
  }

  getTickets(pageEvent, opt?: Options): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (opt?.q) {
      builder.q = opt.q;
    }

    if (opt?.query) {
      builder.query = opt.query;
    }

    if (opt?.filter) {
      builder.filter = opt.filter;
    }

    if (opt?.sort) {
      builder.sort = opt.sort;
    }

    if (opt?.startDate) {
      builder.startDate = opt.startDate;
    }

    if (opt?.endDate) {
      builder.endDate = opt.endDate;
    }

    return this.apiServer.ticket.getTickets(builder.build());
  }

  exportTickets(builder): Observable<any> {
    return this.apiServer.ticket.exportTickets(builder);
  }

  getTicket(ticketNo): Observable<any> {
    return this.apiServer.ticket.getTicket(ticketNo);
  }

  saveTicket(params): Observable<any> {
    return this.apiServer.ticket.saveTicket(params);
  }

  cancelDraftTicket(params): Observable<any> {
    return this.apiServer.ticket.cancelDraftTicket(params);
  }

  saveTicketFilter(params, isNew): Observable<any> {
    return this.apiServer.ticket.saveTicketFilter(params, isNew);
  }

  deleteTicketFilter(id): Observable<any> {
    return this.apiServer.ticket.deleteTicketFilter(id);
  }

  syncTicket(ticketNo): Observable<any> {
    return this.apiServer.ticket.syncTicket(ticketNo);
  }

  log(ticketNo, params): Observable<any> {
    return this.apiServer.ticket.log(ticketNo, params);
  }

  getProductView(dealerStoreId): Observable<any> {
    return this.apiServer.ticket.getProductView(dealerStoreId);
  }

  removeProduct(dealerStore, serialNo, modelCode): Observable<any> {
    const params = {
      serialNo, modelCode
    };
    return this.apiServer.ticket.removeProduct(dealerStore, params);
  }

  attachmentUrl(ticketInfo, attachment: Attachment, disposition?): string {
    const bos = attachment.bos ? attachment.bos : false;
    let url = `${ this.backend }/ticket/${ ticketInfo.ticketNo }/attachments?disposition=${ disposition }&bos=${ bos }`;
    if (!bos) {
      url = url.concat(`&attachmentId=${ attachment.objectKey }`);
    }
    return url;
  }

  cancelTicket(ticketNo, params): Observable<any> {
    return this.apiServer.ticket.cancelTicket(ticketNo, params);
  }

  updateBos(formData, ticketNo): Observable<any> {
    return this.apiServer.ticket.updateBos(formData, ticketNo);
  }

  updateAttachment(formData, ticketNo): Observable<any> {
    return this.apiServer.ticket.updateAttachment(formData, ticketNo);
  }

  deleteAttachment(params): Observable<any> {
    return this.apiServer.ticket.deleteAttachment(params);
  }

  sendPaymentLink(params): Observable<any> {
    return this.apiServer.ticket.sendPaymentLink(params);
  }

  resendPaymentLink(params): Observable<any> {
    return this.apiServer.ticket.resendPaymentLink(params);
  }

  cancelPaymentLink(params): Observable<any> {
    return this.apiServer.ticket.cancelPaymentLink(params);
  }

  creditCardPayment(params): Observable<any> {
    return this.apiServer.ticket.creditCardPayment(params);
  }

  getAttachmentsList(params): Observable<any> {
    return this.apiServer.ticket.getAttachmentsList(params);
  }

  getTicketLogs(params): Observable<any> {
    return this.apiServer.ticket.getTicketLogs(params);
  }
}
